import PerfectScrollbar from 'perfect-scrollbar';
import $ from "jquery";

// Ъплоад СВ - Кариери
document.addEventListener('DOMContentLoaded', () => {
    const fileInput = document.getElementById('careers_applier_cv');
    const display = document.getElementById('fileDisplay');

    if(fileInput){
        fileInput.addEventListener('change', () => {
            if (fileInput.files.length > 0) {
                display.textContent = fileInput.files[0].name;
            } else {
                display.textContent = "CV - Drag and drop your file here, or upload file";
            }
        });
    }
});


// Делегиране на събитие за динамично добавени елементи
document.addEventListener('click', function(event) {
    // Проверяваме дали кликът е върху елемент с клас 'lab'
    if (event.target.closest('.lab')) {
        var officeWorkTime = event.target.closest('.office-work-time');  // Вземаме родителския елемент

        // Добавяме или премахваме класа 'active' на целия офис елемент
        officeWorkTime.classList.toggle('hidden');
    }
});

document.addEventListener('DOMContentLoaded', () => {
    // Избираме всички алърти
    const flashAlerts = document.querySelectorAll('.flash-alert');

    // Активираме всеки алърт с малко закъснение
    flashAlerts.forEach((alert, index) => {
        setTimeout(() => {
            alert.classList.add('active');
        }, (index + 1) * 2500); // Закъснение от 500ms между всеки алърт
    });
});

// Затваряне на алъртите при клик
document.addEventListener('click', (e) => {
    if (e.target.closest('.flash-alert span')) {
        const alert = e.target.closest('.flash-alert');
        alert.classList.remove('active');
        setTimeout(() => {
            alert.style.display = 'none'; // Скриване след анимацията
        }, 500); // Синхронизирано с анимацията
    }
});

document.addEventListener("DOMContentLoaded", function () {
    // Избиране на елементите
    const toggleAction = document.getElementById('checkout-toggle-action');
    const toggleProducts = document.getElementById('checkout-toggle-products');

    if (toggleAction && toggleProducts)
        // Добавяне на събитие при клик
        toggleAction.addEventListener('click', () => {
            // Скриване/показване на продуктите
            toggleProducts.classList.toggle('hidden');

            // Завъртане на псевдоелемента ::after
            toggleAction.classList.toggle('rotated');
        });
});

document.addEventListener("DOMContentLoaded", function () {
    // Избиране на всички елементи с клас 'toggle-action'
    const toggleActions = document.querySelectorAll('.toggle-action');

    toggleActions.forEach(action => {
        action.addEventListener('click', () => {
            // Намиране на съответния .toggle-content в същия контейнер
            const parent = action.closest('.toggle-container');
            const content = parent.querySelector('.toggle-content');

            if (content) {
                // Скриване/показване на съдържанието
                content.classList.toggle('hidden');

                // Завъртане на псевдоелемента ::after (или друга стилизация)
                action.classList.toggle('rotated');
            }
        });
    });
});


document.addEventListener("DOMContentLoaded", function () {

    const scrollToTopBtn = document.getElementById("scrollToTopBtn");

    window.addEventListener("scroll", () => {
        if (window.scrollY > 1000) {
            scrollToTopBtn.style.display = "flex";
        } else {
            scrollToTopBtn.style.display = "none";
        }
    });

    scrollToTopBtn.addEventListener("click", () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    });
});

document.addEventListener("DOMContentLoaded", function () {

    // Избираме елементите
    const searchWidget = document.querySelector('.search-widget');
    const mSearch = document.querySelector('.m-search');
    const scrollToTop = document.querySelector('.search-widget');

    // Функция, която ще се изпълнява, когато състоянието на наблюдавания елемент се промени
    const observerCallback = (entries) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) {
                // m-search не е във viewport-а, показваме widget-а
                searchWidget.style.display = 'inline-block';
            } else {
                // m-search е във viewport-а, скриваме widget-а
                searchWidget.style.display = 'none';
            }
        });
    };

    // Настройки на Intersection Observer
    const observerOptions = {
        root: null, // наблюдава се в контекста на viewport-а
        threshold: 0, // активира се веднага щом част от елемента излезе извън viewport-а
    };

    // Създаваме нов наблюдател
    const observer = new IntersectionObserver(observerCallback, observerOptions);

    // Започваме да наблюдаваме контейнера m-search
    if (mSearch) {
        observer.observe(mSearch);
    }

    // Добавяме събитие при клик върху search-widget
    scrollToTop.addEventListener('click', (event) => {
        event.preventDefault(); // Предотвратява стандартното поведение на <a href="#">
        window.scrollTo({
            top: 0,
            behavior: 'smooth', // Плавно превъртане
        });
    });


});


document.addEventListener("DOMContentLoaded", function () {
    const navParents = document.querySelector(".nav-parents");
    const navChildren = document.querySelectorAll(".nav-children");
    const historyStack = []; // Съхранява историята на отворените менюта

    // Показване на подкатегория
    // document.querySelectorAll(".nav-parents a, .nav-children a[data-id]").forEach((link) => {
    //     link.addEventListener("click", function (e) {
    //         e.preventDefault();
    //         const targetId = this.getAttribute("data-id");
    //         const targetMenu = document.querySelector(`.nav-children[data-parent-id="${targetId}"]`);
    //
    //         if (targetMenu) {
    //             const currentMenu = historyStack.length
    //                 ? historyStack[historyStack.length - 1] // Най-горното меню в стека
    //                 : navParents;
    //
    //             // Преместване на текущото меню вляво
    //             currentMenu.style.left = "-100%";
    //             // Показване на новото меню отдясно
    //             targetMenu.style.left = "0";
    //
    //             // Добавяне на новото меню в историята
    //             historyStack.push(targetMenu);
    //         }
    //     });
    // });

    // Връщане към предишното меню
    document.querySelectorAll(".parent-category").forEach((link) => {
        link.addEventListener("click", function (e) {
            e.preventDefault();

            if (historyStack.length > 0) {
                const currentMenu = historyStack.pop(); // Изваждане на последното меню от историята
                const previousMenu = historyStack.length
                    ? historyStack[historyStack.length - 1]
                    : navParents;

                // Преместване на текущото меню вдясно
                currentMenu.style.left = "100%";

                // Връщане на предишното меню в центъра
                if (previousMenu) {
                    previousMenu.style.left = "0";
                }
            }
        });
    });

    // Когато натиснеш btn-m-menu, изпразваме historyStack и връщаме всичко в началното състояние
    const btnMMenu = document.querySelector(".btn-m-menu");
    if (btnMMenu) {
        btnMMenu.addEventListener("click", function () {
            // Изпразвяме historyStack
            historyStack.length = 0;

            const navChildren = document.querySelectorAll(".nav-children");
            // Затваряме всички подменюта
            navChildren.forEach((menu) => {
                menu.style.left = "100%"; // Преместваме всички подменюта извън екрана
            });

            // Показваме основното меню
            if (navParents) {
                navParents.style.left = "0"; // Основното меню трябва да бъде видимо
            }
        });
    }
});

document.addEventListener('DOMContentLoaded', () => {
    const menuAll = document.querySelector('.menu-all');

    if (menuAll) {
        menuAll.onmouseover = () => menuAll.classList.add('open');
        menuAll.onmouseout = () => menuAll.classList.remove('open');

        if (menuAll) {
            const handleScroll = () => {
                const scrollPosition = window.scrollY || window.pageYOffset;

                // Check if scroll is more than 50px and the element has the 'initial-open' class
                if (scrollPosition > 200 && menuAll.classList.contains('initial-open')) {
                    menuAll.classList.remove('initial-open'); // Remove the class
                    menuAll.classList.remove('open'); // Remove the class
                    window.removeEventListener('scroll', handleScroll); // Remove the event listener
                }
            };

            // Add the scroll event listener
            window.addEventListener('scroll', handleScroll);
        }
    }
});

function setSubMenuWidth() {
    // Намираме ширината на .container-fluid
    const containerFluid = document.querySelector('.custom-width');
    const containerWidth = containerFluid.offsetWidth;

    // Намираме ширината на main-categories > li
    const mainCategoryItem = document.querySelector('.link-all');

    if (!mainCategoryItem) {
        return; // Exit if the main category item is not found
    }
    const mainCategoryItemWidth = mainCategoryItem.offsetWidth;

    // Изчисляваме новата ширина за .sub-menu
    const subMenuWidth = containerWidth - mainCategoryItemWidth;

    // Намираме всички .sub-menu елементи и присвояваме новата ширина
    const subMenus = document.querySelectorAll('.sub-menu');
    subMenus.forEach((subMenu) => {
        subMenu.style.width = `${subMenuWidth}px`;
    });
}

// Изпълняваме функцията при зареждане на страницата
window.onload = function () {
    setSubMenuWidth();
};

// Изпълняваме функцията и при оразмеряване на прозореца
window.onresize = function () {
    setSubMenuWidth();
};


$(document).ready(function () {
    $('.btn-m-menu').on('click', function () {
        $('body').addClass('m-menu-open');

        // Затваряме всички подменюта при отваряне/затваряне на мобилното меню
        const navChildren = document.querySelectorAll(".nav-children");
        navChildren.forEach((menu) => {
            menu.style.left = "100%"; // Преместваме всички подменюта извън екрана
        });

        // Връщаме основното меню в началната позиция
        const navParents = document.querySelector(".nav-parents");
        if (navParents) {
            navParents.style.left = "0";
        }
    });

    $('.btn-m-menu-close').on('click', function () {
        $('body').removeClass('m-menu-open');

        // Затваряме всички подменюта при отваряне/затваряне на мобилното меню
        const navChildren = document.querySelectorAll(".nav-children");
        navChildren.forEach((menu) => {
            menu.style.left = "100%"; // Преместваме всички подменюта извън екрана
        });

        // Връщаме основното меню в началната позиция
        const navParents = document.querySelector(".nav-parents");
        if (navParents) {
            navParents.style.left = "0";
        }
    });

    const fileInput = document.getElementById('file-input');
    const fileLabel = document.getElementById('file-label');

    if (fileInput) {

        // Слушаме за промяна в избора на файл
        fileInput.addEventListener('change', function () {
            if (fileInput.files.length > 0) {
                // Добавяме клас за избран файл
                fileLabel.classList.add('active');
                fileLabel.textContent = fileInput.files[0].name;
            } else {
                // Връщаме оригиналния стил, ако няма избран файл
                fileLabel.classList.remove('active');
                fileLabel.textContent = "";
            }
        });
    }


    $('.view-options').on('click', function (e) {
        e.preventDefault();
        $('.delivery-features').toggleClass('features-opened');
    });

    $('.toggle-content').on('click', function (e) {
        e.preventDefault();
        $('.content-nav').toggleClass('content-opened');
    });


// Функция за изчисляване на ширината на скролбара
    function getScrollbarWidth() {
        return window.innerWidth - document.documentElement.clientWidth;
    }

// Функция за забрана на скрол и компенсация на скролбара
    function disableScroll() {
        const scrollbarWidth = getScrollbarWidth();
        document.body.style.overflow = 'hidden';
        document.body.style.paddingRight = `${scrollbarWidth}px`;
    }

// Функция за разрешаване на скрол
    function enableScroll() {
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
    }

    // Добавяне на клас при фокус или въвеждане
    $('.main-search.search input[type=text]').on("focus input", function () {
        if ($(this).val().length > 0 || $(this).is(':focus')) {
            $('body').addClass('search-show');
            disableScroll(); // Забранява скролването
        } else {
            $('body').removeClass('search-show');
            enableScroll(); // Връща скролването
        }
    });

    // Премахване на класа при загуба на фокус, ако няма текст
    $('.main-search.search input[type=text]').on("blur", function (e) {
        if ($(this).val().length === 0) {
            $('body').removeClass('search-show');
            enableScroll(); // Връща скролването
        }
    });

    // Премахване на класа при щракване върху overlay
    $('.search-overlay').on("click", function () {
        $('body').removeClass('search-show');
        $('.main-search.search input[type=text]').val(''); // Опционално: изчиства текста
        enableScroll(); // Връща скролването
    });

    $(document).on("click", ".overlay, .cart-close, .btn-cart-close", function (e) {
        e.preventDefault();

        $('body').removeClass('cart-show');
    });

    $('.btn-cart').on("click", function (e) {
        $('body').toggleClass('cart-show');

        e.preventDefault();
    });

    function moveSlider(slider) {
        let direction = 1;
        let position = 0;

        function animate() {
            const sliderWidth = slider.offsetWidth;
            const wrapperWidth = slider.parentElement.offsetWidth; // родителският елемент като контейнер

            position += direction * 1;

            if (position > sliderWidth - wrapperWidth || position < 0) {
                direction *= -1;
            }

            slider.style.transform = `translateX(-${position}px)`;
            requestAnimationFrame(animate);
        }

        animate();
    }

// Намираме всички елементи с клас 'slider' и стартираме движението за всеки от тях
    const sliders = document.querySelectorAll('.slider');
    sliders.forEach(slider => moveSlider(slider));


    $(".photo-gallery ul li .thumbnail").click(function () {
        $(".photo-gallery ul li .thumbnail").removeClass("active");
        $(this).addClass("active");
    })

    $('.carousel').carousel({
        interval: 2500,
        touch: true
    });

    $('.sort h3').click(function (e) {
        $('.sort .sort-result').slideToggle(function () {
            $('.sort').toggleClass('active');
        });
        e.preventDefault();
    });

    $('.sidebar h3, .toggle-filter').click(function (e) {
        $('.sidebar .widgets').slideToggle(function () {
            $('.sidebar').toggleClass('active');
        });
        e.preventDefault();
    });

    $('.aside-dropdown .dd-menu > a').click(function (e) {
        $(this).siblings('ul').slideToggle(function () {
            $(this).parent().toggleClass('dd-menu-active');
        });
        e.preventDefault();
    });

    $('.search-widget').click(function () {
        $('.search').toggleClass('open');
    });

    $('.nav-btn').click(function () {
        $(this).toggleClass('open');
        $('nav').toggleClass('open');
    });

    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        $('.dropdown-btn').click(function () {
            $(this).siblings('ul, .mega-menu').slideToggle();
            $(this).find('.fa').toggleClass('fa-angle-down fa-angle-up');
        });
    } else {
        $('.menu > li').hover(function () {
            $(this).find('.mega-menu, .sub-menu').first().stop().slideDown(200);
        }, function () {
            $(this).find('.mega-menu, .sub-menu').stop().slideUp(200);
        });
    }

});

// Object.defineProperty(HTMLMediaElement.prototype, 'introVideo', {
//     get: function () {
//         return !!(this.currentTime > 0 && !this.paused && !this.ended && this.readyState > 2);
//     }
// });

// scrollTop Y function
function scrollTo(position, speed) {

    speed = (typeof speed === "undefined") ? 500 : speed;

    $('html, body').animate({
        scrollTop: position
    }, speed);
}

document.addEventListener('DOMContentLoaded', function () {
    setupCategoryClickListeners();

    function setupCategoryClickListeners(element) {
        if(element){
            element.querySelectorAll('.category-link').forEach(async item => {
                await addCategoryClickListener(item, element);
            });
        }else {
            document.querySelectorAll('.category-link').forEach(async item => {
                await addCategoryClickListener(item, document);
            });
        }
    }

    async function showLoadingSpinner(categoryLink, showSpinner) {
        if(showSpinner) {
            let spinner = document.createElement('span');
            spinner.classList.add('loader-blue', 'me-4');
            categoryLink.appendChild(spinner);
        }else{
            categoryLink.querySelector('.loader-blue').remove();
        }
    }

    async function addCategoryClickListener(categoryLink) {
        categoryLink.addEventListener('click', async function (e) {
            if(!categoryLink.classList.contains('show-all')){
                e.preventDefault();
                const categoryId = e.target.dataset.id;
                const navChildrenElement = document.querySelector(`.nav-children[data-parent-id="${categoryId}"]`);
                if (!navChildrenElement || navChildrenElement.querySelector('.nav-children')) return;

                await showLoadingSpinner(categoryLink, true);
                await fetchCategories(categoryId, navChildrenElement, categoryLink);
                await showLoadingSpinner(categoryLink, false);
            }
        });
    }

    async function fetchCategories(categoryId, containerElement, categoryLink, isTopLevel = false) {
        const url = `/ajax/lazy-load-children/${categoryId}`;
        await fetch(url)
            .then(response => response.text())
            .then(data => {
                if (data) {
                    containerElement.innerHTML = '';
                    containerElement.innerHTML = data;
                    if(containerElement.querySelectorAll('li').length === 2){
                        window.location.href = categoryLink.getAttribute('href');
                        return;
                    }

                    containerElement.style.left = '0';

                    setupCategoryClickListeners(containerElement);
                    prefetchChildCategories(containerElement);

                    addBackButton(containerElement, isTopLevel);
                } else {
                    console.error('No categories found or error fetching categories.');
                }
            })
            .catch(error => console.error('Error loading categories:', error));
    }

    function prefetchChildCategories(navChildren) {
        navChildren.querySelectorAll('.category-link').forEach(link => {
            const childCategoryId = link.dataset.id;
            if (childCategoryId) {
                const childNavChildrenElement = document.querySelector(`.nav-children[data-parent-id="${childCategoryId}"]`);
                if (!childNavChildrenElement) {
                    // Pre-fetch child categories and prepare their containers
                    const placeholder = document.createElement('ul');
                    const loadingLi = document.createElement('li');
                    loadingLi.className = 'sr-only';
                    loadingLi.textContent = 'Loading...';
                    placeholder.appendChild(loadingLi);

                    placeholder.classList.add('nav-children');
                    placeholder.setAttribute('data-parent-id', childCategoryId);
                    placeholder.setAttribute('data-url', '/ajax/lazy-load-children/' + childCategoryId);

                    link.closest('div').appendChild(placeholder);
                    setupCategoryClickListeners(link);
                }
            }
        });
    }

    function addBackButton(navChildren, isTopLevel) {
        const backButton = navChildren.querySelector('.back-button');
        if (backButton) {
            backButton.addEventListener('click', function () {
                navChildren.style.left = '100%';
            });
        }
    }

    function hideNavChildren(navChildren) {
        navChildren.style.left = '100%';
    }
});

let activePopupNav = null;
const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints;

document.addEventListener("DOMContentLoaded", function () {
    const navLinks = document.querySelectorAll(".intro circle");
    let popup = document.createElement("div");
    popup.classList.add("intro-popup", "products-list");
    document.body.appendChild(popup);

    navLinks.forEach(nav => {
        if (!isTouchDevice) {
            nav.addEventListener("pointerenter", function (event) {
                showProductPopup.call(this, event, activePopupNav, popup);
            });
        } else {
            nav.addEventListener("click", function (event) {
                event.stopPropagation();
                showProductPopup.call(this, event, activePopupNav, popup);
            });
        }
    });

    // Скриване на popup при клик извън него
    document.addEventListener("click", function () {
        popup.style.display = "none";
        activePopupNav = null;
    });

    // Предотвратяване на скриването при клик вътре в popup-а
    popup.addEventListener("click", function (event) {
        event.stopPropagation();
    });
});

function showProductPopup(event, activePopupNav, popup) {
    event.stopPropagation(); // Спира разпространението, за да не се затвори popup веднага

    let navId = this.getAttribute("data-intro-nav");
    let productItem = document.querySelector(`.product-item[data-intro-content="${navId}"]`);

    // Ако кликнем на същия активен линк - скриваме popup-а
    if (activePopupNav === this) {
        popup.style.display = "none";
        activePopupNav = null;
        return;
    }

    if (productItem) {
        popup.innerHTML = productItem.outerHTML;
        popup.style.display = "block";

        let navRect = this.getBoundingClientRect();
        let popupHeight = popup.offsetHeight;
        let popupWidth = popup.offsetWidth;

        let topPos = navRect.top + window.scrollY + navRect.height + 10; // Позиция под circle
        let leftPosRight = navRect.left + window.scrollX + navRect.width + 10; // Позиция вдясно
        let leftPosLeft = navRect.left + window.scrollX - popupWidth - 10; // Позиция вляво

        // Проверяваме наличното пространство вдясно и вляво
        let spaceRight = window.innerWidth - leftPosRight;
        let spaceLeft = leftPosLeft;

        // Ако има повече място вдясно, показваме попъп-а отдясно, в противен случай отляво
        if (spaceRight > popupWidth) {
            popup.style.left = `${leftPosRight}px`;
        } else if (spaceLeft > popupWidth) {
            popup.style.left = `${leftPosLeft}px`;
        } else {
            // Ако няма достатъчно място и в двете посоки, центрираме попъп-а
            popup.style.left = `${(window.innerWidth - popupWidth) / 2}px`;
        }

        popup.style.top = `${topPos}px`;

        activePopupNav = this; // Задаваме активния popup
    }
}
